export default {
    pathwayApiUrl: 'https://pathway-api.best-start.dev',
    clientId: '42a4ea08-5b5b-47c1-a2cf-5398663b73c9',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 5,
    sampleRate: 0
};
